export default __webpack_public_path__ + "static/media/49k.72bec3fb.md";